import { AtlasLabel, AtlasLabelOptions } from '../../mu-atlas/interfaces/mu-atlas-types.interface';

export class MuMapLeafletLabel implements AtlasLabel {
  readonly text: string;
  readonly color: string;
  readonly fontSize: string;
  readonly fontFamily: string;
  readonly className: string;

  constructor(options: AtlasLabelOptions) {
    this.text = options.text;
    this.color = options.color ?? '#000';
    this.fontSize = options.fontSize ?? '14px';
    this.fontFamily = options.fontFamily ?? 'Roboto, Arial, sans-serif';
    this.className = options.className ?? '';
  }
}
